// The Dash CS WhatsApp number, from env (CRA only inlines REACT_APP_* vars).
export const DASH_CS_WHATSAPP_NUMBER =
  process.env.REACT_APP_DASH_CS_WHATSAPP_NUMBER;

/**
 * Opens WhatsApp in a new tab. Pass a `message` to pre-fill a draft (the user
 * still presses send themselves); omit it to open a plain chat with no text.
 */
export const openWhatsApp = (message?: string): void => {
  const phoneNumber = DASH_CS_WHATSAPP_NUMBER;
  if (!phoneNumber) {
    console.error(
      'REACT_APP_DASH_CS_WHATSAPP_NUMBER is not set — cannot open WhatsApp.'
    );
    return;
  }
  const url = message
    ? `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`
    : `https://wa.me/${phoneNumber}`;
  if (typeof window !== 'undefined') {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
};

// Format a raw WhatsApp number (e.g. "6281977656763") for display
// (e.g. "+62 819 7765 6763"). Returns '' when no number is provided.
export const formatWhatsAppNumber = (raw?: string): string => {
  if (!raw) return '';
  const digits = raw.replace(/\D/g, '');
  if (digits.startsWith('62')) {
    const rest = digits.slice(2);
    const groups = [rest.slice(0, 3), rest.slice(3, 7), rest.slice(7)].filter(
      Boolean
    );
    return `+62 ${groups.join(' ')}`.trim();
  }
  return `+${digits}`;
};

// Pre-filled drafts for the sign-in page (formal "Anda" register, per prototype).
export const WA_MESSAGES = {
  resetPassword:
    'Halo tim Dash, saya lupa kata sandi akun LINK saya dan butuh bantuan untuk reset.',
  register:
    'Halo tim Dash, saya ingin mendaftar akun LINK untuk platform klien.',
} as const;
